<template>
    <div :style="`background: ${data.bgColor}`" class="grow-item d-flex flex-md-row flex-column align-items-center">
        <div>
            <Icon :icon="data.icon"/>
        </div>
        <div>
            <p data-type="main-text">
                {{data.title}}
            </p>
            <p data-type="main-text" data-name="desc">
                {{data.desc}}
            </p>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
export default {
    name: 'GrowItem',
    components: {
        Icon
    },
    props: {
        data: {
            type: Object
        }
    }
}
</script>

<style lang="scss" scoped>
$mob_title: 18px;
$mob_desc: 16px;
$mob_line_height: 24px;
$mob_radius: 80px;

.grow-item {
    max-width: 632px;
    border-radius: 120px;
    padding-left: 70px;
    padding-right: 60px;
    padding-top: 44px;
    padding-bottom: 44px;
    margin-bottom: 24px;
    &:last-child {
        margin: auto;
    }
    div {
        &:first-child {
            img {
                min-width: 82px;
            }
        }
        &:last-child {
            margin-left: 50px;
            p {
                &:first-child {
                    font-size: 23px;
                    font-family: 'EinaBold';
                }
                &:last-child {
                    margin-top: 8px;
                    line-height: 28px;
                }
            }
        }
    }
}
@media (max-width: 767px) {
.grow-item {
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 40px;
    padding-bottom: 32px;
    margin-top: 24px;
    margin-bottom: 0;
    border-radius: $mob_radius;
    &:last-child {
        margin-top: 24px;
    }
    div {
        text-align: center;
        &:first-child {
            img {
                margin-bottom: 16px;
                min-width: 42px;
                width: 42px;
            }
        }
        &:last-child {
            margin-left: 0;
            p {
                &:first-child {
                    font-size: $mob_title;
                    line-height: $mob_line_height;
                }
                &:last-child {
                    font-size: $mob_desc;
                    line-height: $mob_line_height;
                }
            }
        }
    }
}
}
</style>